import AnimatedSection from '../common/AnimatedSection'
import { servicesWhyChoose } from '../../data/servicesPageData'

function ServicesWhyChoose() {
  return (
    <AnimatedSection className="services-why-section">
      <div className="container corp-container">
        <header className="services-section-header services-section-header--center">
          <span className="section-label section-label--gold">Why Choose Us</span>
          <h2>
            Built for <span>Dependable</span> Global Trade
          </h2>
          <p>
            Practical execution, transparent communication and consistent quality across every
            engagement.
          </p>
        </header>

        <div className="row g-4">
          {servicesWhyChoose.map((item) => {
            const Icon = item.icon
            return (
              <div className="col-md-6 col-xl-3" key={item.title}>
                <article className="services-why-card">
                  <span className="services-why-card__icon" aria-hidden="true">
                    <Icon />
                  </span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              </div>
            )
          })}
        </div>
      </div>
    </AnimatedSection>
  )
}

export default ServicesWhyChoose
